export enum SocialMediaType {
  Facebook = 'FCB',
  Website = 'HPG',
  Twitter = 'TWT',
  LinkedIn = 'LIN',
  Other = 'OTH',
}

export enum SocialMediaTypeDropdown {
  FCB = 'Facebook',
  HPG = 'Website',
  TWT = 'Twitter',
  LIN = 'LinkedIn',
  OTH = 'Other',
}

export enum AddressCategoryTypes {
  Mailing = 'Mailing',
  Physical = 'Physical',
  Records = 'Records',
  Social = 'Social',
  Plant = 'Plant',
  AccountPayable = 'AccountPayable'
}

export enum BusinessPreferenceCorrespondenceKeys {
  LET = 'postal',
  INT = 'e-mail',
}

export enum OffsettingPreferencesKeys {
  Z01 = 'program_account_level',
  Z02 = 'program_type_level',
  Z03 = 'legal_entity_level',
}

export enum SubProgramResponseKeys {
  canadianGoodsAbroadStatus = 'canadian_goods_abroad',
  // coastingTradeLicenseStatus = 'coasting_trade_licence',
  containerBankStatus = 'container_bank',
  csaStatus = 'trusted_trader',
  dutyReliefLicenseStatus = 'duty_relief_licence',
  // dutyRemissionStatus = 'duty_remission',
  ediStatus = 'edi',
  rppStatus = 'release_prior_payment',
  rsavrStatus = 'reporting_summary_accounting',
}

export enum ProgramInformationTemplateTypes {
  Importer = 'Importer',
  Carrier = 'Carrier',
  CustomsBroker = 'CustomsBroker',
  ThirdParty = 'ThirdParty',
  Exporter = 'Exporter',
  Warehouse = 'Warehouse',
}

export enum ContactTypes {
  Officer = 'Z003',
  Clerk = 'Z005',
  Supervisor = 'Z002',
  Dispatcher = 'Z004',
  Secretary = 'Z006',
  Other = 'Z099',
  Manager = 'Z001',
  Employee = 'Z007',
  EDI = 'Z097',
  QualifiedOfficer = 'Z008',
  Director = 'Z009',
  CRACollections = 'Z012'
}
